"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _domainServices = require("@site/domain-services");
var _utils = require("@site/utils");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
class UrlHelper {
  /**
   * @method domainServices
   * @param {object} args args object
   * @param {String} args.apiKey the url in its initial state
   * @param {String} args.plid the private label id
   * @param  {String} urlOverride override the default host
   * @returns {Object} @site/domain-services object
   */
  static domainServices = ({
    apiKey = 'cart_basket',
    plid = 1
  }, urlOverride) => {
    return new _domainServices.DomainServices({
      apiKey: apiKey,
      plid: plid,
      env: (0, _utils.getEnv)(urlOverride),
      resellerBaseOverride: urlOverride,
      market: _jsCookie.default.get('market') || 'en-US',
      fetchEntity: global.fetch || {}
    });
  };
}
var _default = exports.default = UrlHelper;